import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[appCpfCnpjMask]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CpfCnpjMaskDirective),
            multi: true
        }
    ]
})
export class CpfCnpjMaskDirective implements ControlValueAccessor {
    private onChange: (value: string) => void = () => { };
    private onTouched: () => void = () => { };

    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        const formatted = this.formatar(value);

        // Atualiza o valor visual no <input>
        this.el.nativeElement.value = formatted;

        // Notifica o Form/ngModel do Angular
        this.onChange(formatted);
    }

    @HostListener('blur')
    onBlur(): void {
        this.onTouched();
    }

    writeValue(value: string): void {
        const formatted = this.formatar(value || '');
        this.el.nativeElement.value = formatted;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    // --- LÓGICA DE REGEX E MÁSCARA ---
    private formatar(val: string): string {
        if (!val) return '';

        // 1. Converte tudo para maiúsculas e remove caracteres especiais
        let raw = val.toUpperCase().replace(/[^A-Z0-9]/g, '');

        // 2. Descobre se o input contém alguma letra
        const temLetra = /[A-Z]/.test(raw);

        // 3. Se NÃO tiver letras E tiver até 11 caracteres -> Trata como CPF
        if (!temLetra && raw.length <= 11) {
            return raw
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        }

        // 4. Se tiver LETRA ou mais de 11 caracteres -> Trata como CNPJ Alfanumérico

        // Garante que o CNPJ tenha no máximo 14 caracteres brutos
        raw = raw.substring(0, 14);

        // Garante que as últimas 2 posições (DV) sejam estritamente numéricas
        let base = raw.substring(0, 12);
        let dv = raw.substring(12, 14).replace(/[^0-9]/g, '');

        const fullRaw = base + dv;

        // Aplica a máscara do CNPJ à medida que o usuário digita
        return fullRaw
            .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
            .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
            .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
            .replace(/\/([A-Z0-9]{4})([0-9]{1,2})$/, '/$1-$2');
    }
}